export default __webpack_public_path__ + "static/media/Home_gray.72c02dab.svg";